module.exports = __webpack_public_path__ + "static/media/es-ct.af551905.svg";